import { useState, useEffect } from 'react';

const useJobRecommender = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRecommendedJobs = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/jobs/recommended-jobs`, {
          method: 'GET',
          credentials: 'include', 
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        setItems(data.data || []); // Use data.data instead of data.jobs
      } catch (error) {
        setError(error);
        console.error('Error fetching recommended jobs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRecommendedJobs();
  }, []);

  return { items, loading, error };
};

export default useJobRecommender;
